import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { ALIAS_VERIFICATION_STATUS } from "../components/LipaBidhaa/config/verificationStatus";

const INITIAL_STATE = {
  isFlowActive: false,
  paymentType: null,
  currentStep: 1,
  businessName: null,
  alias: null,
  accountNumber: null,
  transactionAmount: null,
  transactionFee: null,
  totalAmount: null,
  aliasVerificationStatus: ALIAS_VERIFICATION_STATUS.IDLE,
  aliasVerificationMessage: null,
  verifiedAlias: null,
  otpRecipient: null,
  confirmationMode: null,
  walletBalance: null,
  transactionUuid: null,
  remarks: null,
  otpAuthorizationSubmitted: false,
};

const useLipaBidhaaStore = create(
  persist(
    (set) => ({
      ...INITIAL_STATE,
      activateFlow: () => set({ isFlowActive: true }),
      deactivateFlow: () => set({ isFlowActive: false }),
      setPaymentType: (paymentType) => set({ paymentType }),
      setCurrentStep: (currentStep) => set({ currentStep }),
      setPaymentDraft: ({ alias, accountNumber, transactionAmount }) =>
        set({
          ...(alias !== undefined && { alias }),
          ...(accountNumber !== undefined && { accountNumber }),
          ...(transactionAmount !== undefined && { transactionAmount }),
        }),
      setAliasVerification: ({
        aliasVerificationStatus,
        businessName,
        verifiedAlias,
        aliasVerificationMessage,
      }) =>
        set({
          aliasVerificationStatus,
          businessName,
          verifiedAlias,
          aliasVerificationMessage: aliasVerificationMessage ?? null,
        }),
      setTransactionCharges: ({ transactionFee, totalAmount }) =>
        set({ transactionFee, totalAmount }),
      setWalletBalance: (walletBalance) => set({ walletBalance }),
      setOtpRecipient: (otpRecipient) => set({ otpRecipient }),
      setConfirmationMode: (confirmationMode) => set({ confirmationMode }),
      setTransactionUuid: (transactionUuid) =>
        set({ transactionUuid, walletBalance: null }),
      setTransactionFailed: (remarks) => set({ remarks }),
      setTransactionResult: ({ id }) => set({ transactionUuid: id, otpRecipient: null }),
      setOtpAuthorizationSubmitted: (otpAuthorizationSubmitted) =>
        set({ otpAuthorizationSubmitted }),
      resetVerification: () =>
        set({
          aliasVerificationStatus: ALIAS_VERIFICATION_STATUS.IDLE,
          aliasVerificationMessage: null,
          businessName: null,
          verifiedAlias: null,
        }),
      reset: () => set(INITIAL_STATE),
    }),
    {
      name: "lipa-bidhaa-store",
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) => ({
        isFlowActive: state.isFlowActive,
        paymentType: state.paymentType,
        currentStep: state.currentStep,
        alias: state.alias,
        accountNumber: state.accountNumber,
        transactionAmount: state.transactionAmount,
        transactionFee: state.transactionFee,
        totalAmount: state.totalAmount,
        aliasVerificationStatus: state.aliasVerificationStatus,
        aliasVerificationMessage: state.aliasVerificationMessage,
        verifiedAlias: state.verifiedAlias,
        businessName: state.businessName,
        otpRecipient: state.otpRecipient,
        confirmationMode: state.confirmationMode,
        walletBalance: state.walletBalance,
        transactionUuid: state.transactionUuid,
        remarks: state.remarks,
        otpAuthorizationSubmitted: state.otpAuthorizationSubmitted,
      }),
    },
  ),
);

export default useLipaBidhaaStore;
